import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link, Switch, Redirect, Route, useRouteMatch } from "react-router-dom";

import { updateLoginStatus } from "../../../store/userSlice";
import { SubPageHeader } from "../../SubPageHeader";
import { Events } from "./Events";
import { ContinuousData } from "./ContinuousData";
// import { SearchEventRecord } from './SearchEventRecord'
import { Fdsnws } from "../openapi/Fdsnws";
import { KEsmDB } from "./KEsmDB";

const PAGE_NAMES = {
  "event-data": "이벤트파형자료",
  "continuous-data": "연속파형자료",
  // 'event-records': 'K-ESM DB',
  "web-services": "FDSN Web Services",
};

export function Data() {
  let match = useRouteMatch();
  const currentPath = window.location.pathname;
  const currentPage = currentPath.substring(
    currentPath.lastIndexOf("/") + 1,
    currentPath.length
  );

  // Update login status
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateLoginStatus());
  }, [currentPage, dispatch]);

  return (
    <div>
      <SubPageHeader
        categoryUrl={match.path}
        categoryName="data"
        pageName={currentPage}
      />
      <Switch>
        <Route exact path={`${match.path}`}>
          <Redirect to={`${match.path}/event-data`} />
        </Route>
        <Route path={`${match.path}/event-data`}>
          <Events />
        </Route>
        <Route path={`${match.path}/continuous-data`}>
          <ContinuousData />
        </Route>
        <Route path={`${match.path}/event-records`}>
          {/* <SearchEventRecord /> */}
          <Redirect to="/analysis/kesmdb" />
        </Route>
        <Route path={`${match.path}/web-services`}>
          <Fdsnws />
        </Route>
        <Route path={`${match.path}/kesmdb`}>
          <KEsmDB />
        </Route>
        <Route>
          <div className="container">
            <div className="sub-container">
              <h3>페이지를 찾을 수 없습니다.</h3>
              <span>
                <Link to="/">홈 화면으로 가기</Link>
              </span>
            </div>
          </div>
        </Route>
      </Switch>
    </div>
  );
}
